<template>
  <van-row>
    <van-sticky>
      <van-nav-bar
          title="简历详情"
          left-text="返回"
          left-arrow
          @click-left="onClickLeft"
      />
    </van-sticky>
    <div v-if="is_temp ==0">
      <div class="resume-detail" v-if="show">
        <div class="resume-top">
          <div class="resume-avatar">
            <img :src="resumeData.photosrc">
          </div>
          <div class="resume-top-right">
            <div class="name">{{resumeData.fullname}}</div>
            <div class="more-info">
              <span class="lab">{{resumeData.sex_cn}}</span>
              <span class="lab"> {{resumeData.age}}岁</span>
              <span class="lab">{{resumeData.education_cn}}</span>
              <span class="lab"> {{resumeData.experience_cn}}</span>
            </div>
          </div>
        </div>
        <div class="split-block"></div>
        <!-- 特长标签-->
        <div v-if="!isEmptyVal(resumeData.tag_cn)">
          <div class="r-tag">
            <div class="r-title">特长标签</div>
            <div class="tag-box"><span v-for="(tag,i) in resumeData.tag_cn" :key="i">{{tag}}</span></div>
          </div>
          <div class="split-block"></div>
        </div>
        <!-- 求职意向-->
        <div class="r-intent">
          <div class="r-title">求职意向 </div>
          <div class="r-tr">
            <div class="l-tit">求职状态：</div>
            <div class="r-txt">{{resumeData.current_cn}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">工作性质：</div>
            <div class="r-txt">{{resumeData.nature_cn}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">期望行业：</div>
            <div class="r-txt">{{resumeData.trade_cn}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">期望职位：</div>
            <div class="r-txt">{{resumeData.intention_jobs}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">期望地区：</div>
            <div class="r-txt">{{resumeData.district_cn}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">期望薪资：</div>
            <div class="r-txt">{{resumeData.wage_cn}}</div>
          </div>
        </div>
        <div class="split-block"></div>
        <!-- 教育经历-->
        <div v-if="!isEmptyVal(resumeData.education_list)">
          <div class="r-edu">
            <div class="r-title">教育经历 <span>{{resumeData.education_list.length}}段教育经历</span></div>
            <div class="edu-list desc">
              <div class="edu-li" v-for="(edu,i) in resumeData.education_list" :key="i">
                <div class="cname substring">
                  {{edu.school}}<span class="font13">[{{edu.duration}}]</span>
                </div>
                <div class="jname substring font13" v-if="edu.todate==1">
                  {{edu.startyear}}.{{edu.startmonth}}
                  至今
                  | {{edu.education_cn}} | {{edu.speciality}}
                </div>
                <div class="jname substring font13" v-else>{{edu.startyear}}.{{edu.startmonth}}
                  - {{edu.endyear}}.{{edu.endmonth}}
                  | {{edu.education_cn}} | {{edu.speciality}}
                </div>
              </div>
            </div>
          </div>
          <div class="split-block"></div>
        </div>
        <!-- 工作经历-->
        <div v-if="!isEmptyVal(resumeData.work_list)">
          <div class="r-work">
            <div class="r-title">工作经验 <span>{{resumeData.work_duration}}做了{{resumeData.work_count}}份工作</span></div>
            <div class="work-list desc">
              <div class="work-li" v-for="(work,i) in resumeData.work_list" :key="i">
                <div class="cname substring">
                  {{work.companyname}}<span class="font13">{{work.duration}}</span>
                </div>
                <div class="jname substring font13" v-if="work.todate==1">
                  {{work.startyear}}.{{work.startmonth}}
                  至今
                  | {{work.jobs}}
                </div>
                <div class="jname substring font13" v-else>
                  {{work.startyear}}.{{work.startmonth}}
                  - {{work.endyear}}.{{work.endmonth}}
                  | {{work.jobs}}
                </div>
                <div class="wtxt font13">{{work.achievements}}</div>
              </div>

            </div>
          </div>
          <div class="split-block"></div>
        </div>

        <!-- 培训经历-->
        <div v-if="!isEmptyVal(resumeData.training_list)">
          <div class="r-work r-train">
            <div class="r-title">培训经历 <span>{{resumeData.training_list.length}}段培训经历</span></div>
            <div class="work-list desc">
              <div class="work-li" v-for="(train,i) in resumeData.training_list" :key="i">
                <div class="cname substring">
                  {{train.agency}}<span class="font13">{{train.duration}}]</span>
                </div>
                <div class="jname substring font13" v-if="train.todate==1">
                  {{train.startyear}}.{{train.startmonth}}
                  至今
                  | {{train.course}}
                </div>
                <div class="jname substring font13" v-else>
                  {{train.startyear}}.{{train.startmonth}}
                  - {{train.endyear}}.{{train.endmonth}}
                  | {{train.course}}
                </div>
                <div class="wtxt font13">{{train.description}}</div>
              </div>
            </div>
          </div>
          <div class="split-block"></div>
        </div>
        <!-- 获得证书-->
        <div v-if="!isEmptyVal(resumeData.credent_list)">
          <div class="r-recer">
            <div class="r-title">获得证书</div>
            <div class="r-recer-list">
              <div class="r-recer-li" v-for="(cre,index) in resumeData.credent_list" :key="index">
                <div class="cre-name">{{cre.name}}</div>
                <div class="cre-time"><span>获得时间：</span>{{cre.year}}年{{cre.month}}月</div>
              </div>
            </div>
          </div>
          <div class="split-block"></div>
        </div>
        <!-- 语言能力-->
        <div v-if="!isEmptyVal(resumeData.language_list)">
          <div class="r-lang">
            <div class="r-title">语言能力</div>
            <div class="tagul">
              <div class="tagli" v-for="(lang,i) in resumeData.language_list" :key="i">
                {{lang.language_cn}}<span>{{lang.level_cn}}</span>
              </div>
            </div>
          </div>
          <div class="split-block"></div>
        </div>

        <!-- 自我描述-->
        <div v-if="!isEmptyVal(resumeData.specialty)">
          <div class="r-des">
            <div class="r-title">自我描述</div>
            <div class="r-des-txt">
              {{resumeData.specialty}}
            </div>
          </div>
        </div>
        <div class="split-block"></div>
        <div class="r-cantact">
          <div class="r-title">联系方式</div>
          <div class="r-tr" v-if="!isEmptyVal(resumeData.telephone_)">
            <div class="l-tit">手机：</div>
            <div class="r-txt" v-html="resumeData.telephone_"></div>
          </div>
          <div class="r-tr" v-if="!isEmptyVal(resumeData.email)">
            <div class="l-tit">邮箱：</div>
            <div class="r-txt" v-html="resumeData.email"></div>
          </div>
          <div class="r-tr" v-if="!isEmptyVal(resumeData.qq)">
            <div class="l-tit">QQ：</div>
            <div class="r-txt" v-html="resumeData.qq"></div>
          </div>
          <div class="r-tr" v-if="!isEmptyVal(resumeData.weixin)">
            <div class="l-tit">微信：</div>
            <div class="r-txt" v-html="resumeData.weixin"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="resume-detail" v-if="show">
        <div class="resume-top">
          <div class="resume-avatar">
            <img :src="resumeData.photosrc">
          </div>
          <div class="resume-top-right">
            <div class="name">{{resumeData.fullname}}</div>
            <div class="more-info">
              <span class="lab">{{resumeData.sex_cn}}</span>
              <span class="lab"> {{resumeData.age}}岁</span>
              <span class="lab"> {{resumeData.experience_cn}}</span>
            </div>
          </div>
        </div>
        <div class="split-block"></div>
        <!-- 求职意向-->
        <div class="r-intent">
          <div class="r-title">求职意向 </div>
          <div class="r-tr">
            <div class="l-tit">期望岗位：</div>
            <div class="r-txt">{{resumeData.trade_cn}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">期望职位：</div>
            <div class="r-txt">{{resumeData.intention_jobs}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">期望地区：</div>
            <div class="r-txt">{{resumeData.district_cn}}</div>
          </div>
          <div class="r-tr">
            <div class="l-tit">期望薪资：</div>
            <div class="r-txt">{{resumeData.wage_cn}}</div>
          </div>
        </div>
        <div class="split-block"></div>



        <!-- 自我描述-->
        <div v-if="!isEmptyVal(resumeData.introduce)">
          <div class="r-des">
            <div class="r-title">自我描述</div>
            <div class="r-des-txt">
              {{resumeData.introduce}}
            </div>
          </div>
        </div>
        <div class="split-block"></div>
        <div class="r-cantact">
          <div class="r-title">联系方式</div>
          <div class="r-tr" v-if="!isEmptyVal(resumeData.telephone_)">
            <div class="l-tit">手机：</div>
            <div class="r-txt" v-html="resumeData.telephone_"></div>
          </div>
          <div class="r-tr" v-if="!isEmptyVal(resumeData.email)">
            <div class="l-tit">邮箱：</div>
            <div class="r-txt" v-html="resumeData.email"></div>
          </div>
        </div>
      </div>
    </div>
  </van-row>
</template>

<script>
import {mapState} from 'vuex'
import {isEmpty} from '@/utils/common'

export default {
  name: 'ResumeView',
  data() {
    return {
      show:false,
      is_temp :0
    }
  },
  computed:{
    ...mapState('common', ['resumeData','jobfairInfo']),
  },
  created() {
    this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration:0,
    })
  },
  mounted() {
    let is_temp = 0;
    if(this.jobfairInfo.jobfair.is_temp){
      is_temp = this.jobfairInfo.jobfair.is_temp
      this.is_temp = is_temp
    }
    this.$store.dispatch('common/resumeDetail',{resumeId:this.$route.query.resumeId,is_temp:is_temp}).then(()=>{
      this.show=true
      this.$toast.clear()
    })
  },
  methods:{
    onClickLeft() {
      this.$router.go(-1)
    },
    isEmptyVal(param) {
      return isEmpty(param)
    }
  }
}
</script>

<style lang="stylus" scoped>
.p-namecard {
}
.m-list {
  padding-top: .3rem;
}
.u-bottom {
  margin-bottom: .2rem;
}
.tip-box{
  width: 80%;
  position: fixed;
  top: .5rem;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
}
.tip-box .tip-txt{
  color: white;
  font-size: .3rem;
  padding: 0.2rem;
  text-align: center;
}
.g-window .m-article{
  padding-top: .6rem;
}
/*职位详情*/
.resume-detail{
  background-color: #fff;
  font-size: .3rem;
}
.resume-detail .resume-top{
  display: flex;
  align-items: center;
  padding:.3rem;
}
.resume-detail .resume-top .resume-avatar{
  margin-right: .21rem;
}
.resume-detail .resume-top .resume-avatar img{
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 1px solid #f3f3f3;
}
.resume-detail .resume-top .name{
  color: #333333;
  font-size: .36rem;
  margin-bottom:.2rem;
}
.resume-detail .resume-top  .more-info span{
  color: #7a797a;
  background-color: #f8f8f8;
  padding: 0.1rem;
  font-size: .24rem;
  margin-right: .2rem;
}
.resume-detail .resume-top  .more-info span:last-child{
  margin-right: 0;
}
.resume-detail .split-block{
  height: .3rem;
  background-color: #f3f5fa;
}
.resume-detail .r-tag .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAYAAAABtRhCAAADJklEQVRIia2Xe2hOcRjHPzPXkJEotlNmK1ZWW8iYhD9EolxCqUUICYVfLea2Gk7KH0pMVm5/iJK5Fn9QNNdcSiHX34ZJ+2Mkl9mm5/S86+x4z/ue921PnZ73/M7z+31/z/15M3L2tZMGHQQKgWnW0JrK9u7poAHrlA8CvqaysVvI+mbgWoJ954A3QHPwg+Nyw3G5lyrgbGAGsDvk+0IgD/gTAJP16cCoVAEXAZ+B/nG+jQEmAROBYsftdEY9cAsYFwaYKGh6Ab/19yzVSjQfHJATmfPAZWs4FXZYFMAY1QDLfO/i2xeqzQhgtS/4rgNLrKEpGeBIDQI/ZQFPxTXAA2ArcBf4rjL9RDtraHFccoADwHzgFzDBGm9vBzmud7lmsX8V8Bo46fOZrN9RsBPAeL19DCwTeC9B47jUAj+sYQFQCfQG6hyX4T6wCuAtcFgOvq3RthTo6zNNAbATKItjmTZgLLBYtAGaHJcqa9gOrAL6qDViFIv2WgG8AgwDSoFGIF8qiCb0rhBXtKuGZ6xhCOAC5Y5LmTUcVVdkOy5TVV4uVyBBFS9ojugt5wAXw5wfI2s6zLYWGKpmFQU+AI+todgvH8xD8c1y9VVSsADwIU2fJmuwwEOgyHG9S4QC5muIX0oFzEdizgv6GsvJUr9AsHjnKn+WDpo1VIP3CDUoz/bLBDWMvafVswIUa1udlAoCvlNe2AWAecrrEwG+Uj6zCwDnKa9LBNgCnAYGai6mRVplSoDn1iTWUGi/8ur04Dw6rrwi+CEe4BN9pKBvSRXJcVmhTfibNV7bSgqI+rBBS1ZlCmDrNRfbwlwSNkQ1aof4BGwDJgN7w+Ycx/W6/yZfoJRYw6N4smEaoiPGaOAsMAW4mkC2WsFkvCiyhvthglHn0i/gdYUdwN/ARSXBy6WXWkNGsoOizqVSH1cmaFdCN6McFBVwA3BMtWsNlL5MPedlVwL+1CpUoOb0A4oZ6635fyiOR1F92NM3MoZRrjUdtTiUomooJW8uMEBHD7+WWarlxygHRQWUw2U666H5JlzWJMFrrPHyNhKl+u9pI7AnsCYz6ZpIu4F/xk/NJP1zLo8AAAAASUVORK5CYII=");
}
.resume-detail .r-tag .tag-box{
  display: flex;
  padding: .2rem .3rem;
}
.resume-detail .r-tag span{
  padding: .2rem .5rem;
  margin-right: .2rem;
  border-radius: .5px;
  margin-bottom: .2rem;
  background-color: #f7f8ff;
  color: #5e76ff;
}
.resume-detail .r-tag span:last-child{
  margin-right: 0;
}
.resume-detail .r-intent{
  background-color: #fff;
  padding-bottom: .2rem;
}
.resume-detail .r-title{
  padding: 0 .2rem 0 .9rem;
  height: .9rem;
  line-height: .9rem;
  color: #333333;
  border-bottom: 1px #F2F2F2 solid;
  background-repeat: no-repeat;
  background-size: .4rem;
  background-position: .3rem center;
    font-size: .32rem;
}
.resume-detail .r-intent .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAADEklEQVRIiZ2WS2xNQRjHf613vYNI0AkhIp712FhoEEVVQ+tRj7DAgtgyCRKPBYkJkVhYeCR2lDakoo2GhFiQsEARgmAEUTSppEjQynf63bq99zj39H7JvXPnzMz53f/Mf76ZnLa2NrIJ4zgEbAMGJQ3/DbQAP/Qjv38BL4ADWcGM4wKwCpDBd4DeQF8tBwL9gW4pw252zwJUA5QCV4Eyb4N/HtZPYH2AXsAXYEyXlBnHFWApcN1birow7ifQHFuZKhLQjTCQcRQCZ4BxQB2w0dtAEapscG5MULVOnShaENI+FriloI9AsfRN6vINyMsIM45LQDlQGzF15VoWecsI4AQwzThm6PPv8hUJ06lbrlNXEtH1k5ZzjMMAk7XepGVLJEzNUKqgtKlLiYvAQ2Av8BaC9TvqLW8yKjOOKjVDfQwQ3gYbeCawEzgJrPeWHUldAmVpbkyyd523LMkESgL+AY78p/lzmrIUe8cGxYgJnWBJaxRq72zDOLYCc4G7QQZJynVxzBAaxjFa8qG3vEoScBDYDTQCU3KN46yCarIBGcd243gHvAZeGkeTcQFAQvaZpKoCb2nMyT8cJMf33jIqC9BpYLNW6yEwSbHWz3nLOuMY5u0/g3wFRhrHvC6CNinonuQ9b1mkpuqp+26tcdgESEKUTQTu63GwxlsqY4BydR0GyBnmLa0hfQQyFOjnrWYQb3kKTNc+541jdRxhwBB1bhpIo1rLROpqt763PAem6rNK46jIAEucwqEHZ0pbx4ndsc+8pUHsqVVRuCLiRV7zXZR7l2n5JA2mwMeqUBxaZRxloaT2q4Ak3Tw9gjqFcRwD8oE93tKcaAu9FhjHeAimlijTGMdlVdCia9Sq1h+uXcSh9ZEwfZFM6SOtVngbZJlE2y4BeMtx49gP7EsZLteDDboNCr3ldiRMXypOatDqYm+5ZhxbgFOiwtv2xTcuuEHJFsoBnnnLd+OCUz2hapK4PuPtyrjgJQ+AHjp4oZ7Ms70NUlTUWNnkcuWTmJ/xDqL7sAD4oCBx16xMIB1bC6wMKlDyFyBMGLCHQyZDAAAAAElFTkSuQmCC");
}
.resume-detail .r-tr{
  display: flex;
  padding: 0.2rem .3rem;
}
.resume-detail .r-tr .l-tit{
  color: #6d6c6c;
  width: 2.2rem;
}
.resume-detail .r-edu{
  background-color: #fff;
}
.resume-detail .r-edu .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAABoElEQVRIie3WO2gVQRTG8d+NF8FHBNFGxLna+ChCKsXOxsbCQisrGwvBVllbbUS3sRCxFcHCQhRNJYTYWAl2pggoMoKNjUkkQnysTJwL6yXqJbsXLPI1h/129vx3hnNmplNVlVDagSkcNbwWMT4wOnmbsQHLuNnZc6NKD2/Qw0W8HQKxN32Ma3hZ8x/hGW7jFpa6uJSTj8fC52H+P5S2ZMD9WJit+UkzsfAklM5h/xhOJNKwybN6Oe5e5d32HNNSLSfA17xeI1ECfMtxZICRah3QHTVgzq/63/WnnE0APzARSq/xIZRO4wu+twUYy1vDVjzGQ2zi94ZdK2Axx6lY6MXCKVzI3kJjQCy8x4FYOFnz7mAf7tbH/rMK/gKZW8V7N+itN9r/AejkM7RtLWFjNydfCOUK7Hg+yFOXVg2AVS7ZjwkQcWSwxVvSvW5u7W14gPOxMN9G7lB6isMJcDCdybFwJpQmQ+lsbZprVfp2ErP9Tu6X6wQru2JTJcBOzKeL1zE8x5VYuNrW4ofSi3RB618dr+MyXuFTLt0mSjM4hOmfCPZqd5qwrlAAAAAASUVORK5CYII=");
}
.resume-detail  .r-title span{
  font-size: .28rem;
  color: #339900;
  float: right;
}
.resume-detail .r-edu .edu-list{
  padding: .3rem .35rem;
}
.resume-detail .r-edu .edu-li{
  margin-left: 0.2rem;
  border-left: 1px solid #eee;
  position: relative;
  padding-left: 0.5rem;
  padding-bottom: 0.3rem;
}
.resume-detail .r-edu .edu-li:before{
  content: "";
  position: absolute;
  left: -.18rem;
  width: 0.15rem;
  height: 0.15rem;
  border-radius: 50%;
  background-color: #1d89ff;
  border: 0.1rem solid #d2e6ff;
}
.resume-detail .r-edu .edu-li.last{border-bottom:0px;}
.resume-detail .r-edu .edu-li .cname{height:.5rem;line-height: .45rem}
.resume-detail .r-edu .edu-li .cname span{color:#999999;padding-left:.3rem;}
.resume-detail .r-edu .edu-li .jname{height:.6rem;line-height: .6rem;color: #999999;}
.resume-detail .r-edu .edu-li .jname span{color:#999999;}
.resume-detail .r-edu .edu-li .wtxt{color:#999999;word-break:break-all;}
.resume-detail .r-edu .more{margin:0 auto;height:.5rem;padding-top:.2rem;text-align:center}
.resume-detail .r-work .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAbCAYAAACEP1QvAAACRklEQVRIieXWOWgVQRgH8F/igeCtCF5ZPMBCxCMRj0JSiFiJFoL2ghYKdmtn76KgKAhWFhaihYWCWIgSsBGjIsYmNq5ExSNGRYJH8mSek/DM9ZL3Xl7jB8vM7M78//t9810NhUJBOUkyrTiNtehD/whHGjANr3E2T10shzte8i4sLbvxX1mRp16NtWHqOIFmxnEPno9yrj++f4i5WEZtyHsj4K08HXtjkvkRp2/KgRbNnmQWIcBuwXQMvYvtcQxafxsLD9vi/AW+DPnWH98Hn+hoaDpVWI32qFk9pTWY/UwkfhC1/4opVfxEQ3z64jggYT0DJ7AfV4LmnzEPG/LUs3ponmR/r7VxAk5XcwnkvyJoWe+cTPJjSWb5ZJIlmeYkcz4ue8Od52gq2fMINynef1ue6h4FKMH14EB56v4oe4LDbcUOHEBLyefuQP4Wi/EYzSNgdMbYDOH4Dj34iIM4HBIPTmIB5mNhSK0xN2zCnBKs37iGvcHXAnl3PLQS3+OhjdiNzTHpVCMvcQd3cS9P9SSZn6EIBfJP8a9b8rSofanZQiSsw5pYWJZgPWZhVXwX8kJXHENG64g5PVS39qHFJcmKyhRTcGmYDQu5PC2a6Wl8ht7nUVzA1Tx1ZAKWaRw2qUAGQrOzUoCKyfPUjeig5yrFqCq75akn1ZyvxuxVy/9NPlBzy3eStZFBnsZY4IOMmMNrLXk62OMVyd/H+c56kCfZYD8opNfjoaGL6zZ8iM1/rSVky9nYFYEvD3Svl3Cojt5/G/v+AKsjmySo1iXHAAAAAElFTkSuQmCC");
}
.resume-detail .r-work .work-list{
  padding: .3rem .35rem;
}
.resume-detail .r-work .work-li{
  margin-left: 0.2rem;
  border-left: 1px solid #eee;
  position: relative;
  padding-left: 0.5rem;
  padding-bottom: 0.3rem;
}
.resume-detail .r-work .work-li:before{
  content: "";
  position: absolute;
  left: -.18rem;
  width: 0.15rem;
  height: 0.15rem;
  border-radius: 50%;
  background-color: #1d89ff;
  border: 0.1rem solid #d2e6ff;
}
.resume-detail .r-work .work-li.last{border-bottom:0px;}
.resume-detail .r-work .work-li .cname{height:.5rem;line-height: .45rem}
.resume-detail .r-work .work-li .cname span{color:#999999;padding-left:.3rem;}
.resume-detail .r-work .work-li .jname{height:.6rem;line-height: .6rem;color: #999999;}
.resume-detail .r-work .work-li .jname span{color:#999999;}
.resume-detail .r-work .work-li .wtxt{color:#999999;word-break:break-all;}
.resume-detail .r-train .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAC30lEQVRIieWXX4gNURzHP3v32r2thPxXTu2DJJ6Uf9kkS4qXjRRWIvKiJGUS5UFKppCSQrEKedhYD/4nD9hiHygRT7YhZGM9oIvL6jd+ZxvTvTNnR3dffGv6zcw5Z77nd875/n6/qZl0oK8RWA2MAn5QfeSBL0C73BwCWgaBNI5WIZ8LvAZWAUOAmiqTFgFPHM4r4VvgfpYvBd7AxxifJ0KeA74DdVmI/wHDZWhukEn/wv9LnnfsJ3u0GVgElIArwHHgZ7XJ5wCdKsFvOmYpsAeYAbzJSp627GNVgqKIBUBByVcC44B7xqchK3ma51t1gjMh1KZFO7AcuAisBU7YBuMzFKiPbUkYuAKPT9HnNM/Fw94YscUltYsjxJIjPgMfICSyl3yj1/j9gazo4nnJYYJ9kfvnwBH1rC/WT9690PtaF/ILwF5gFvAw1rZG7XX7IvB4BOGVhjoX8qPAbuABsAy4qu/XA6eBZ8A529n4TNQEVa+rFvVackhX4HHTtqWRy14tBO6otqOQTNgceKH8LJYABxO+1w00qnqcdN6pnqzQ9CuzvgXcLtP3PPC0zH5bvFJbcCVHA80InfEv1f80JeqHrkL8bFREGvlIoAOYX6G9DdjgShZHkowkcj1W4l3ABD04ck0FDsvBMz53yw02PuuMz5Ss5HKKDdAE7AfeRdpEz9uBLdJu/FARUeJNwBlgXhbyyVpUXk4pr47pvu+LxfiTmnDOZiFvUtuWNFjRoVa2Rby2um8JvD+SGih5QW2PA/l7td3GZ7RGvlOBR1fawErk9n2pQnsUtk+DBiOR3EaHcRXJKwWJpL6S5aZrMHJCTjNM/DepVq3LD0RRbTNwI/DCHJ+Gr2iQkZkPA8ZrAdCj5VJ0EkmI9mlN6mh8xqjDUgWF5C+B2frXYr213rgsv/3h2BZ4YRGRBHs4wxUT8h2qaUmHdgKSTKRALFfBxCFpdmfghUVEGiQqiiQ/Atd+A7GlpMsR3dwiAAAAAElFTkSuQmCC");
}
.resume-detail .r-recer .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAEwklEQVRYhZ2YDWiWVRTHf765ZQmr4dQ031WWKaaZlRoryyyTtWmrhLQPchSEplaU8yMqMSi3CjFNTNRikoUN1L6F0r6WQSvRstB05maFZX6hppEujvwv3J7d+7zqgZf7PM8999xzz8f/nPu2yVa3cArUF7gWuAa4AbjQW3sc+Ab4CNgErAL+ySW7qQranqQCY4BxwGDv2zFgA7ATOAu4CBikn6NFwEygOU14LiUGAC95m9cB7wJfAVsD/PmeIo8BD+pXC7yqda0ozR1VQLWe5wEvAjtyKJ2kocBq77B2mC99HnNHJrL4ZSlgph4CTDwNBYzWAH2An/T+ueLpfxRS4hVt+jGQBT47jc192gz0Bu41ywPrgJ4+QzImHgfGS+NhOYQPBEqArsqCzTL9HxH+N2TNL4AGoDNwOKlEsfy+X+kXo0rgeQkx+gsoAPL0bqk5HfgxsN7i4QFgMfAWMJKEO5ZrLI1snicXLQG2ALcDZwJFyoruwLPALcKJsRE5SyRnhDusU+ImpdXb8lmItojvev1WJsBoO/A0cLbS+jVgakRWucalvhIuFR+KLFoldOwmnxrdD3ynzXcIQy7Q3BPKMHPb5QF5R4Ud2eIaBmQUC1cB9cDewIJ+8t3DwK/69ibwug5RKwC7E/gFuFU8jyjF34scrEZjZUYmRhAbokmAIdp8zT0DjAZuA67Q+wQv/d4H2nsWsTS/MiDX4maXBWpGYGL0fUQJs8IHeraNZgiE3gnwlmh07v1E480R2RaD+b4lNkQYizzEcym9LMKL/D1cz7s1FkZ4LZ5wltgD/BthNNy4VM+OpyJFCUvbtYnN96XIPqHEGe4lQhZ0ZZpqUUCVq6YkabXeJ2t0oLcmIvtvp8Qh4JwUJeZI0Xv0PkXBt1Y+nyak/U1Adbd3KFP4dzU7IToBEW2VVpelKNGgIrZU6bZflpis31Dxfao0dWD3KNADuC5FdoGzhGs0eqQwm+mPyLe99O0FoJPg3LLmRk8BS9vZwpL6FLmFTomN+tAnhXmSWrg9ypTl6jXzvGDtonLdrDRuVB3qlyK31CnhtB8RYbxPcfEt0EEK3aGKuFOAY37fJpeZtc6TizvL0l0Ccs/VQb7OSPifKtFJKhMsG5xfrbm5iqWeUqqTNrXDtFNHvkvuG6mCts4r9Y5Ga1zgCpjDcb+AVXq4X6jyuwLoqG+9lDXd1FEPEVAZ3aVCN0PvVtgOAJd48p/SuMI1um1kxgKd8pgKkOH+QZ3wYmCU9aZAfzUzH3oFq0WY8qTibJOqbKPmz1fH3aDuzdrI6qYqpvrd9ihh+Uo1LCEqVtneLcWKvNOXSwmkQCzQszqIuaxrUxXH/c6qToWqQoAUoia5rEjuOurxmOt+0POgyHq8lC3Vra1Vo1umFJul0y4OCFmooKsLzFWozhwKzLlMzOqQ6/2JJJUoWxYJjkNUG/m+TXGSpL6y4kCBXI0/H1KiWej5s64AjV6fcKqUrz5zowJzim52rUwUIle+Z+miW6/aMEYBmYt6KwWPqM/cKmCqCa3LdSG2Cmm+NxywVHSl2QLYOjFzm6WwAZFVYsMMq6TW/htZ4D6n9VE6mb8GDFEtYK0G2K3MLi+mkMOHEBl8W2xYjTHMiRPwH5pEHfPbGc/DAAAAAElFTkSuQmCC");
}
.resume-detail .r-des .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAADKUlEQVRIiZ2WaaiOQRSAH1y7iJv1ZrJG5AeJLEmWhFCy5ocoueIXGdeWpWyDLuVSflBCSMpalpIfRPYIWZKxh0LZ5eq8navx3e/93u/9Tn3NzPudM8+cmTPnTI3KykqSxDgaAVOB4UB3VX8EnAX2ecvHxEkCSYQaxwygAqgfoyITzPOW7flCayYAHbBLgduAwUBDoAEwANgkC5dFGZc/NNZT45gF7AQ+CcxbbsXodQXOASWA9ZaNBUGNowj4pcNO3vIk1yTG0RJ4rV639pY3ufTjtnemtuuSgCLe8hZYoMOFSfpx0GnalidNEMgO7U4vFNoN+O0t7/Ilest33eJi46hTCLSuXoW08iNh3px/PgRqGxddj7zEuCiI2gE/1evU0NPajkvh6QhtTyQpxkErtN2SArpN2/UFQb3lFbAHaG4cJ5MmMY5DQEfgqLdcLQiqYAn9y8Ao43hgHCOzwIYZxw1gInAbGB+zqFrhOJ+EvxhYo9nmqf7EyACdVW2Vt6zMYiu34DrQDBjkLY9zehqInNF+HbYHhgBDA+ARYG0WYG3gmpbC1sBN4+iU01PjogSxApgUfP4AvFdPi+XMg/8OA7u95ZTay9n2llSqNpshqrv9imKAc4NofK3RfF5W6y3fgq3rqeWuFJigCzllHGcUuNdblqi+LLAMuF/NU+OiHFqqw9neRuUtUYxjjC5sHzAWOOQtk3XOYj2GQcCB/6BaiOcAz4CB3vIiH2BgL1srUX7C22gRVR5KLW4j9dlbZv+D6rNEXgkvJeF7y+eUwItAf+C4t5GnWYFUBZJxNNFDFungbXQt0gAvSYBkAJsC94BWIVCkKpC2aluWBmgc9YALQB/goLdMCTy8osByb5kf2tVou6Gysb6DvnqbqqrIs1Q87CEpUzNY5pau9ZalmbY1g9RVUW3m3DJagcdigOXZgFXQ4do/nR/rn/TSziIFtgiAWzK3NJQirQ4id1NCS7SdaBxfgGUQBc8mb3M/zgTaV/t5v4dUZGtFVgfflsu1k6oESKz8ybCRnb0jUMkgJd5WU4gVLVXPIUoeUjmkvN2WB7lxUTHoEmsMv/4CUyIK0ty4WjMAAAAASUVORK5CYII=");
}
.resume-detail .r-lang .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAfCAYAAABgfwTIAAACS0lEQVRYhc2YS0iUURTHf46TRS+iMMGe9KBAbC1EIYSVizAiMhCKCqxduXAiqHYtDAKHcCMWtcqNm4ikBxFELzdtWgblhNGDHJASeqhx5P/FZRgZv9d884c758733Tn3x73nPs5UreuZQToOnAYaKK9SwEdgAOjNZZhOq/vbwDHV35cZyrQeuAYcAZpspNqBQSALnCs3TS4jqqucBG4Yh0F9AlYD6VIO4oQS2FsLn5SAPicBVESvUZD9rBAgUw2CsuVXFdLZGmAPsDGkn9T/jwjUDzwGnkbhLAqolcA+1TcAe8M6jALqPFANvND3i2EdRgF1RvYo8AXYJcjEoBqB5cCQjopbet6ZJNRl2TuyD2XPhnEaFuqw7APZJ0Ae2AbUJgHVKtsH/HCeX5K9kARUVvZKwfObsl1BAz7oIVwHbFV9BJiSr6mC06EJeF4uqHbZvGJnofPuD/AdWAV0B4EKMn3VzqrbDyzS6HilRiNkatMuHztUs0ZhQlNXTO+ANw547FAnZHtLtPNGs8tvB36h1gIdqmdLtL3n7FnNfjrxG+iTihcL5PF5tG8McrP1CzXuXVnnqTEVX7LpWwD89fvDmPQLQaV10leClnlQd4EVwKYKgLJ9bczyPtuRv+qIOAC8isC5baKLlSnl52izVKFj2qxEdAew26bumzKRR8D9CICKaRS4rtQcAduKXFLQ9lQuwzP3Dw5ruNOZxpk5uyitaZV6YDtwUAB2xbErz0vgkM7N31qhI7nM7FaDCxW3WoBh4AOwxevMTdtnBfwDwRdv3Ix2efgAAAAASUVORK5CYII=");
}
.resume-detail .r-cantact{
  padding-bottom: .3rem;
}
.resume-detail .r-cantact .r-tr{
  align-items: center;
}
.resume-detail .r-cantact .r-tr .l-tit{
  width: 1rem;
}
.resume-detail .r-cantact .r-title{
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEYklEQVRYhaWXe4zdQxTHP70Vj0bQYhPRzFYI9baIR9NKqq9EkGVJvbOqHlEJ1hoVQZCUTCNtCUu9gqAaNFRaJdpIs1VFquIRDZuYqESVaLyiEStn8v1d4/Z37969Pf+c38yc3znfOXPOmTMjBgcHaZZc4FhgGjAZOAYYp1//BL4CPgHWAG9Gz8/NqB0SgAvsAfQC5wMnlojsAHYvmX8NeCH6xFsD4AIzgCeBsZr6EXgZeAvYCGmXf0MC2Q6cBHQKbEHLge56HqkLwAX6gOs0XAaE6FnfaDfZvwfomBYABwO/AXOi57mmALiQdmi7/wu4KXoea8ZwiZ69gIeBqzQ1M3qWNgTgAu8AU4EtQEf0ye27RC7QDTwjHT3RJ8/sDMCFhPYGGT81+sSLtTYFoQXd+uj5Y5jeuMSCUsP26In2UckEjpRxo+NrjJ8H/ACsBN4FvnWB/YcDIHpeBOZr2F/MVzKZIl16o+enzPiV2dpDkBRZkL3XAggPrLWscoFbqwBc4ApgvKVW9DyYGTeXP63hlOi5MXouhSRzNKRMGS5dJvm5uQeuFr+5Rtn94hdHz+psJ736nDFc6zr7j4AxLtBZcYFRwEStr62RP0U/LcknXeAefX7QggeM7hO/xTxwtgYrouefGsEtMnhgZvwJ4C5gAJjVIgCrM2ZrYiXb/RslgmvEp/BfPs8GvlGafteK9ehTKn9q3wbgCM1/WSL7uHjhsnbxO6JnWyvGM/q4ADBGc9tLkH4GfAgcpkL0qJbm7KJxo20FgOLcK3UE7xRfprJsgTrJhf/deK1QKsG7QbXo7FumJHpWuZAajQku0AVMVwPyqgucnt+QunzMO6fJxYsalOxRxa4HNDGujqDRGeKvAHsCB2n8voqYGR+r4LRya0DnWVy5wD51dB5eANigiWn1rEfPr5AuE2Rkh9LXju9ZF9gEbBawPmWWcQesk2dqaYKN7QhWaGEmpDJbD8RLCsSFdmzRMwIY6UK6nM6U2G3RE/TdL/kueXBVocuF1DmZZwYqSqeNUtbR4BgMxCJIF4opGXSBi6JPNcIK1fjMeEGbxWvj627xhUXkF13K3EYABMLOuFtD80qfbSL61BVXyQUmAbdrvCGbtwb2HA0Xp4ZEgRKFdHr0qStqSC6kmHkg65SXKEUHFB9FrZgVfbUbsv8eAa4Hnoqe2dWOyIWEysrx9ujZbygAmcJ5OpaRJctdeVvuAucCr2vYZnWltiVbrW52ZfScNQwQltMdCrY2PVBMx9ZM5ijgcw2nRp+Cd6ee0I5ik2rC8ugT4l0mFzgZeBsYbe+M6Kv9R2lXPFrxsDfwheV/9AlUS+QC12SX2oLo6cn11HsXHKrMKAKsR8+src2CcIHjdI9coKnF0XNtrdxQT7N7s8vI6Hk9zfqj55c6wCcrA07QtF1gndGzrsxGM49Tu1gsbS6vWfpaF5m9nuy4DtEZ5+v2DpgfPb/X09/081wt+IUqItaMlqXd9yrtS5upJQD/Asxqe2bjnoRIAAAAAElFTkSuQmCC");
}
.resume-detail .r-recer{
  padding-bottom: .3rem;
}
.resume-detail .r-recer .r-recer-list{
  padding: .2rem .3rem .2rem .3rem;
  color: #666666
}
.resume-detail .r-recer .r-recer-list .r-recer-li{
  padding: .2rem 0;
}
.resume-detail .r-recer .r-recer-list .r-recer-li .cre-name{
  padding: .2rem 0;
}
.resume-detail .r-recer .r-recer-list .r-recer-li .cre-time span{
  color: #aaaaaa;
}
.resume-detail .r-lang .tagul{
  display: flex;
  padding: .2rem .3rem;
}
.resume-detail .r-lang .tagul .tagli{
  padding: .2rem .3rem;
  margin-right: .2rem;
  color: #f19e38;
  border-radius: .05rem;
  background-color: #fffaee;
  margin-bottom: .2rem;
}
.resume-detail .r-lang .tagul .tagli span{
  color: #333;
  padding-left: .2rem;
}
.resume-detail .r-des .r-des-txt{
  padding: .2rem .3rem;
  color: #6d6c6c;
  word-break: break-all;
}
</style>
